module.exports = __webpack_public_path__ + "static/media/logo-dark.b3e8039b.png";